const getUrlWithoutQueryParamsAndAnchor = (url: string) => url?.split('?')[0]?.split('#')[0] || '';

/** Returns data to track page view for pages. */
export function getTrackPageViewData(url: string): {
  chapter: string;
  subChapter: string;
  subSubChapter: string;
  page: string;
} {
  const chapter = 'Messagerie_Securisee';
  let subChapter = '';
  const subSubChapter = '';
  let page = '';

  switch (getUrlWithoutQueryParamsAndAnchor(url)) {
    case '/desktop/quick-actions':
      page = 'Accueil';
      break;
    case '/mobile/conversations':
      page = 'Accueil';
      break;
    case '/desktop/conversation-create':
      page = 'Nouveau_Message';
      subChapter = 'Ajout_Tiers';
      break;
    case '/desktop/conversation/new':
      page = 'Nouveau_Message';
      break;
    case '/desktop/conversation':
      page = 'Message';
      break;
    case '/mobile/conversation-create':
      page = 'Nouveau_Message';
      subChapter = 'Ajout_Tiers';
      break;
    case '/mobile/conversation/new':
      page = 'Nouveau_Message';
      break;
    case '/mobile/conversation':
      page = 'Message';
      break;
    case '/service-unavailable':
      page = "Erreur";
      break;
  }

  return {
    chapter,
    subChapter,
    subSubChapter,
    page,
  };
}
